define('views/components/lead_note/lead_notes',['require','views/base/collection_view','views/components/lead_note/lead_note_list','text!templates/components/lead_note/lead_notes.html'],function(require){

    var BaseCollectionView = require('views/base/collection_view');
    var ListView = require('views/components/lead_note/lead_note_list');

    var temp = require("text!templates/components/lead_note/lead_notes.html");
    return BaseCollectionView.extend({
        template: _.template(temp),
        className: 'grid-container lead-note-grid-container',

        onRender: function () {
            this.ListContainer.show(new ListView({
                collection: this.collection
            }));
        }
    });
});

